export default __webpack_public_path__ + "static/media/ClientesIconBlue.736f0253.svg";